import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<App />);

if (process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    if (navigator.storage?.persist) navigator.storage.persist().catch(() => false);
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((registration) => console.info('[IntegraNube POS Retail] Service Worker activo:', registration.scope))
      .catch((error) => console.warn('[IntegraNube POS Retail] Service Worker no disponible:', error));
  });
}
